import { inject } from '@angular/core';
import { LoggerService } from '../services/logger.service';

/**
 * APP_INITIALIZER factory function
 *
 * NOTE: Sync initialization has been moved to syncInitGuard.
 * This allows:
 * - Login/signup routes to load without waiting for sync
 * - Sync to initialize once after authentication (via guard)
 * - Better separation of concerns
 *
 * APP_INITIALIZER now does minimal work and returns immediately.
 */
export function appInitializerFactory(): () => Promise<void> {
  // inject() is valid here — this function is called in the injection context
  // when Angular resolves the APP_INITIALIZER token.
  const log = inject(LoggerService).getLogger('app-init');
  return async () => {
    log.info('✅ Lightweight initialization - sync handled by syncInitGuard');
    // Sync initialization now happens in syncInitGuard when accessing protected routes
  };
}
